import { ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import ruRU from 'antd/lib/locale/ru_RU';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { RouteGuard } from 'components/common/RouteGuard';
import { FullPageLoader } from 'components/ui';
import { routes } from 'config/routes';
import { FormRoutes } from 'pages/FormRoutes';
import { RegisterPage } from 'pages/RegisterPage';
import { rootStore } from 'stores/RootStore';

import { ForbiddenErrorPage } from '../Error';

const App: React.FC = () => {
  const { i18n } = useTranslation();
  const antdLocale = i18n.language?.startsWith('ru') ? ruRU : enUS;
  const { isAuthorizing } = rootStore.userStore;

  const navigate = useNavigate();

  const location = useLocation();

  React.useEffect(() => {
    if (!rootStore.initialized.opened) {
      rootStore.init({
        navigate,
        location,
      });
    }
  }, [location, navigate]);

  if (isAuthorizing) {
    return <FullPageLoader />;
  }

  return (
    <ConfigProvider locale={antdLocale}>
      <Routes>
        <Route path={routes.root}>
          <Route
            index
            element={<Navigate replace to={routes.form.createPath()} />}
          />
        </Route>
        <Route
          path={routes.form.mask}
          element={
            <RouteGuard>
              <FormRoutes />
            </RouteGuard>
          }
        />
        <Route path={routes.error.mask}>
          <Route
            path={routes.error.forbidden.mask}
            element={<ForbiddenErrorPage />}
          />
        </Route>
        <Route path={routes.register.mask} element={<RegisterPage />} />
      </Routes>
    </ConfigProvider>
  );
};

export default observer(App);
